module.exports = __webpack_public_path__ + "img/36600.3f7085c8.jpg";